import React from 'react'
import { ModalDialogContainer } from '@common/modal'
import {
  DialogTitle,
  DialogContent,
  IconButton,
  Button,
} from '@common/material'
import { localizedStrings } from '@core/strings'
import { Text } from '@fundamentals'
import ClearIcon from '@mui/icons-material/Clear'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import { AttachmentInput } from '@elements/Questions/AttachmentInput'
import { AttachmentTypes } from '@core/components/templateAnswersForm'
import { useModal } from '@common/GlobalModal'
import { downloadCSV } from 'webapp/utils'
import {
  arcGisCsvSample,
  ARCGIS_CSV_SAMPLE_FILENAME,
} from '@modules/geolocation'

type ImportArcGisCsvModalProps = {
  onImport: (file: File) => void
}

export const ImportArcGisCsvModal: React.FC<ImportArcGisCsvModalProps> = ({
  onImport,
}) => {
  const { hideModal } = useModal()

  const handleFileUpload = (file: File) => {
    if (!file) return
    onImport(file)
    hideModal()
  }

  const handleDownloadSample = () => {
    downloadCSV(arcGisCsvSample, ARCGIS_CSV_SAMPLE_FILENAME)
  }

  return (
    <ModalDialogContainer>
      <DialogTitle
        variant='h5'
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        sx={{ pr: 1, fontSize: 20 }}
      >
        {localizedStrings.importFromArcGisCsv}
        <IconButton aria-label='close-modal' onClick={hideModal}>
          <ClearIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Text color='grey.600'>
          {localizedStrings.importFromArcGisCsvPrompt}
        </Text>
        <Button
          variant='text'
          startIcon={<FileDownloadOutlinedIcon />}
          onClick={handleDownloadSample}
          sx={{ mt: 1, px: 0 }}
        >
          {localizedStrings.downloadSampleFile}
        </Button>
        <AttachmentInput
          inputProps={{
            onChange: (proofs) => handleFileUpload(proofs[proofs?.length - 1]),
          }}
          attachmentTypes={[AttachmentTypes.CSV]}
          multiple={false}
          maxFiles={1}
          mt={2}
        />
      </DialogContent>
    </ModalDialogContainer>
  )
}
